module.exports = __webpack_public_path__ + "images/ba562625.png";